import React, { useEffect } from 'react';

import { JDPModuleName } from '@/components/job-posting/types';
import { useJobContactsQuery } from '@/graphql/generated';

import { useJobPostingModuleDispatcher } from '../../contexts';
import CompanyContactsModule from './company-contacts-module-component';

type Props = {
  id: string;
  companyName: string;
  companyId: string;
  moduleName: JDPModuleName;
};

const CONTACTS_PER_TYPE = 3;

export const CompanyContactsModuleContainer: React.FC<Props> = ({ id, companyId, companyName, moduleName }) => {
  const dispatch = useJobPostingModuleDispatcher();
  const { loading, error, data } = useJobContactsQuery({
    variables: {
      id,
      /* FIXME: provide correct consumer */
      consumer: 'loggedin.web.jobs.posting.contacts.module',
      first: CONTACTS_PER_TYPE,
      sourceEntityId: companyId,
    },
  });
  const isEmpty = error || !data;

  useEffect(() => {
    if (!loading && isEmpty) {
      dispatch({
        type: 'UPDATE_MODULE_STATUS',
        moduleName,
        status: 'HIDDEN',
      });
    }
  }, [dispatch, isEmpty, loading, moduleName]);

  if (loading || isEmpty) return null;

  return <CompanyContactsModule contacts={data?.viewer} company={companyName} moduleName={moduleName} />;
};
